import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const images = require.context("../emblahome", true);
const imageList = images.keys().map((image) => images(image));

function EmblaHome() {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    speed: 3000,
    autoplaySpeed: 2000,
    fade: true,
    cssEase: "linear",
    adaptiveHeight: false,
    nextArrow: false,
    prevArrow: false,
    arrows: false,
  };
  return (
    <div className=" items-center pt-0 w-full  justify-center flex ">
      <div className="container w-full object-contain ">
        <Slider {...settings}>
          {imageList.map((image, index) => (
            <img key={index} src={image} alt={`image-${index}`} />
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default EmblaHome;
